import {Injectable} from '@angular/core';
import {BehaviorSubject, fromEvent} from 'rxjs';
import {SettingsEvent} from '../classes/settings-event.enum';
import {InteractionService} from './interaction.service';
import {SettingsType} from '../enums/settings-type.enum';

@Injectable({
  providedIn: 'root'
})
export class KeyboardService {

  // Movement codes
  private readonly arrowUpCode = 38;
  private readonly arrowDownCode = 40;
  private readonly arrowLeftCode = 37;
  private readonly arrowRightCode = 39;
  private readonly movementKeys = new Set([this.arrowUpCode, this.arrowDownCode, this.arrowLeftCode, this.arrowRightCode]);

  // Zoom codes
  private readonly plusCode = 107;
  private readonly minusCode = 189;
  private readonly zoomKeys = new Set([this.plusCode, this.minusCode]);

  // Other codes
  private readonly iterationsCode = 73;

  private fractalSettingsEvents: BehaviorSubject<SettingsEvent>;

  constructor(private interactionService: InteractionService) {
    this.fractalSettingsEvents = this.interactionService.fractalSettings;
    window.addEventListener('keydown', (event) => this.handleKeyboardEvent(event));
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    let baseValue;

    if (this.movementKeys.has(event.keyCode)) {
      baseValue = 10;
    } else if (this.zoomKeys.has(event.keyCode)) {
      baseValue = 25;
    } else if (this.iterationsCode === event.keyCode) {
      baseValue = 100;
    }

    const value = baseValue * (event.ctrlKey ? 10 : 1) * (event.altKey ? 100 : 1) * (event.shiftKey ? -1 : 1);

    let settingsEvent;
    switch (event.keyCode) {
      case this.arrowUpCode:
        settingsEvent = new SettingsEvent(SettingsType.DIRECTION_Y, -value);
        break;
      case this.arrowDownCode:
        settingsEvent = new SettingsEvent(SettingsType.DIRECTION_Y, value);
        break;
      case this.arrowLeftCode:
        settingsEvent = new SettingsEvent(SettingsType.DIRECTION_X, -value);
        break;
      case this.arrowRightCode:
        settingsEvent = new SettingsEvent(SettingsType.DIRECTION_X, value);
        break;
      case this.plusCode:
        settingsEvent = new SettingsEvent(SettingsType.ZOOM, value);
        break;
      case this.minusCode:
        settingsEvent = new SettingsEvent(SettingsType.ZOOM, -value);
        break;
      case this.iterationsCode:
        settingsEvent = new SettingsEvent(SettingsType.ITERATIONS, value);
        break;
    }

    if (settingsEvent) {
      this.fractalSettingsEvents.next(settingsEvent);
    }
  }

}
